export class Urls {
  public static getS3() {
    return 'https://sistema-merito.s3.amazonaws.com/';
  }

  public static getDefaultPictureS3() {
    return 'https://s3.amazonaws.com/37assets/svn/765-default-avatar.png';
  }
}
